const regionOptions = [
  { countryCode: "GB", name: "UK", flag: "🇬🇧" },
  { countryCode: "US", name: "USA", flag: "🇺🇸" },
  { countryCode: "BE", name: "Belgie", flag: "🇧🇪" },
  { countryCode: "FR", name: "France", flag: "🇫🇷" },
  { countryCode: "NL", name: "Nederlands", flag: "🇳🇱", language: "nl" },
  { countryCode: "DE", name: "Germany", flag: "🇩🇪" },
  { countryCode: "IE", name: "Ireland", flag: "🇮🇪" },
  { countryCode: "IT", name: "Italy", flag: "🇮🇹" },
  { countryCode: "LU", name: "Luxembourg", flag: "🇱🇺" },
  { countryCode: "ES", name: "Spain", flag: "🇪🇸" },
  {
    countryCode: "CH",
    name: "Switzerland",
    flag: "🇨🇭"
  }
]

const storeOptions = {
  UK: "bleach-sh-uk.myshopify.com",
  US: "bleach-sh-us.myshopify.com"
}

const languageOptions = {
  "en-GB": "English",
  "en-US": "English (US)",
  nl: "Nederlands"
}

const globalDiscountSources = {
  CONTENT: "CONTENT",
  INFLUENCER: "inref",
  VIP: "vip_discount"
}

const errorLevels = {
  GLOBAL: "GLOBAL",
  AUTH: "AUTH"
}

const priceAdjustmentSources = {
  PROMO: "promo",
  SUBSCRIPTION: "sub",
  GLOBAL: "coupon"
}

const promoTypes = {
  VALUE: "VALUE",
  MATCH: "MATCH"
}

const promoMatchableProperties = {
  RANGE: "matchList",
  PRODUCT: "matchProducts"
}

const discountTypes = {
  FIXED: "FIXED",
  PERCENTAGE: "PERCENTAGE"
}

const purchaseTypes = {
  BUYONCE: "BUYONCE",
  SUBSCRIPTION: "SUBSCRIPTION"
}

const subscriptionStates = {
  ACTIVE: "active",
  CANCELLED: "cancelled",
  EXPIRED: "expired"
}

const dateFormats = {
  DAY_DATE_MONTH_YEAR: {
    "en-GB": "EEEE, do MMMM yyyy",
    "en-US": "EEEE MMMM d, yyyy"
  }
}

const orderStatusOptions = {
  PROCESSING: "processing",
  CANCELLED: "cancelled",
  SHIPPED: "shipped",
  REFUNDED: "refunded"
}

const pageSlugPrefixes = {
  FEATURE: "featured",
  TEST: "test"
}

const productTypes = {
  PRODUCT: "Product",
  SET: "ProductBundle",
  GIFT_CARD: "ProductGiftCard"
}

const productRoutes = {
  [productTypes.PRODUCT]: "products",
  [productTypes.SET]: "sets"
}

const quantityStatusTypes = {
  OUT_OF_STOCK: "out-of-stock",
  IN_STOCK: "in-stock",
  LOW_STOCK: "low-on-stock"
}

const rangePriorityOrder = [
  "bleach",
  "tone",
  "permanent",
  "colour",
  "pro blonde",
  "natural",
  "maintain",
  "care",
  "tools"
]

const retailerDomains = {
  "en-US": {
    walmart: "walmart.com",
    cvs: "cvs.com"
  },
  "en-GB": {
    boots: "boots.com",
    superdrug: "superdrug.com"
  }
}

export {
  dateFormats,
  errorLevels,
  globalDiscountSources,
  orderStatusOptions,
  pageSlugPrefixes,
  priceAdjustmentSources,
  productTypes,
  productRoutes,
  promoTypes,
  promoMatchableProperties,
  discountTypes,
  purchaseTypes,
  quantityStatusTypes,
  rangePriorityOrder,
  retailerDomains,
  subscriptionStates,
  storeOptions,
  regionOptions,
  languageOptions
}
